import { api } from '@/global/api'
import {
  ContractOrigin,
  Phone
} from '@/modules/accredited-establishments/api/types'

/*
 * Avaliacao consolidada do especialista. O backend so devolve o objeto quando
 * evaluationsCount >= 10 (MIN_EVALUATIONS_TO_DISPLAY_RATING em
 * AccreditedSpecialistDetailsTransportConverter.kt), por isso rating e opcional.
 */
export interface SpecialistRatingData {
  trustScore?: number
  recommendationScore?: number
  evaluationsCount: number
  appointmentCount: number
  aiGeneratedComment?: string
}

export interface GetSpecialistDetailResponse {
  name: string
  photo?: string
  council?: string
  specialty?: string
  subSpecialties?: string[]
  includedPlans?: string[]
  contractOrigin?: ContractOrigin
  phones?: Phone[]
  address?: string[]
  remote: boolean
  about?: string
  rating?: SpecialistRatingData
  /*
   * education e qualifications chegam como uma unica string: o backend junta a
   * lista com joinToString(separator = "\n"). Quem renderizar precisa quebrar
   * por linha.
   */
  education?: string
  qualifications?: string
  /*
   * Sem consumidor de proposito: o campo existe no contrato do backend, mas o
   * handoff (node 26:40868) nao reserva lugar para ele no drawer. Fica aqui
   * para que o tipo descreva a resposta inteira.
   */
  curiosity?: string
}

export const getSpecialistDetails = async (
  referenced_id: string
): Promise<GetSpecialistDetailResponse> => {
  const { data } = await api.get<GetSpecialistDetailResponse>(
    `/site_accredited_network/accredited_specialist/${referenced_id}`
  )
  return data
}
